/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Divider, Typography } from "@mui/material";
import { productStatusStyle } from "@/src/components/ProductStatus/productStatusStyle";
import { AbstractCase } from "@/src/types/Entities/AbstractCase";
import { getProductData } from "@/src/services/productService";
import ProductStatusNavigationLinks from "@/src/components/ProductStatus/ProductStatusNavigationLinks";
import ProductStatusInquiriesToCustomer from "@/src/components/ProductStatus/ProductStatusInquiriesToCustomer";
import ProductStatusMeta from "@/src/components/ProductStatus/ProductStatusMeta";
import ProductStatusProgress from "@/src/components/ProductStatus/ProductStatusProgress";
import ContentBox from "@/src/components/Box/ContentBox/ContentBox";
import { ReactNode } from "react";

export type ProductStatusProps = {
  product?: AbstractCase;
  headline?: string;
  children?: ReactNode;
};

export default function ProductStatus({ product, headline, children }: ProductStatusProps) {
  return (
    <ContentBox sx={productStatusStyle.productStatus}>
      <Typography component={"h1"} variant={"h5"}>
        {headline || (!!product ? getProductData(product.name, "label") : "")}
      </Typography>
      <Divider sx={{ marginBottom: "1rem" }} />
      {!!product && (
        <>
          <ProductStatusMeta product={product} />
          <ProductStatusNavigationLinks product={product} sx={productStatusStyle.section} />
          <ProductStatusInquiriesToCustomer product={product} sx={productStatusStyle.section} />
          {!product.isDeactivatedProduct && <ProductStatusProgress product={product} sx={productStatusStyle.section} />}
        </>
      )}
      {children}
    </ContentBox>
  );
}
